import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { saveFile } from "../../../helpers/file-saver.js";
import { FullscreenDownloadProgress } from "../../ui/fullscreen-download-progress.jsx";
import { useMutation } from "@tanstack/react-query";
import axios from "../../../api/axios.js";

export function OrthomosaicDownload({ project }) {
  const { t } = useTranslation(["project", "common"]);
  const sizes = [
    {
      name: t("large"),
      size: 75
    },
    {
      name: t("medium"),
      size: 50
    },
    {
      name: t("small"),
      size: 25
    },
  ];
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const abortController = useRef();
  const downloadMutation = useMutation({
    mutationFn: async (size) => {
      abortController.current = new AbortController();
      const res = await axios({
        url: `/project/${project.id}/orthomosaic`,
        params: {
          size
        },
        responseType: "blob",
        signal: abortController.current.signal
      });
      const name = `${project.name}-orthomosaic`;
      const extension = size === 100 ? "png" : "jpg"
      saveFile(res.data, `${name}.${extension}`);
    }
  });

  const download = (
    size
  ) => {
    setOpen(false);
    downloadMutation.mutate(size);
  };

  const cancel = () => {
    abortController.current?.abort()
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
      >
        <Button
          variant="outlined"
          onClick={() => download(100)}
        >
          {t("orthomosaic")} (png)
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={handleToggle}
          ref={anchorRef}
        >
          <ArrowDropDownIcon/>
        </Button>{" "}
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement={"bottom-start"}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: "center top",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem>
                  {sizes.map(size => (
                    <MenuItem
                      key={size.size}
                      onClick={() => download(size.size)}
                    >
                      {size.name} {size.size}% (jpg)
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      {downloadMutation.isPending && <FullscreenDownloadProgress
        totalTimeS={project.orthomosaicSize * 0.00000007}
        onCancel={cancel}
        title={"Exportálás folyamatban..."}
      />}
    </>
  );
}